import {DataRetentionActions, DataRetentionActionTypes} from "../actions/dataRetentionActions";

export const initialDataRetentionState: DataRetentionState = {
  isLoading: false,
}

export interface DataRetentionState {
  isLoading: boolean;
}

export default function dataRetentionReducer(state: DataRetentionState = initialDataRetentionState, action: DataRetentionActions): DataRetentionState {
  switch (action.type) {
    case DataRetentionActionTypes.UPDATE_DATA_RETENTION_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case DataRetentionActionTypes.UPDATE_DATA_RETENTION_SUCCESS:
    case DataRetentionActionTypes.UPDATE_DATA_RETENTION_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
}
